import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import Layout from '../components/layouts/Layout';
import TopBanner from '../pagesContent/Home/TopBanner';
import DefaultContainer from '../components/DefaultContainer';
import DefaultTitle from '../components/DefaultTitle';
import DefaultParagraph from '../components/DefaultParagraph';
import StrengthsContainer from '../pagesContent/Home/StrengthsContainer';
import Tiles from '../pagesContent/Home/Tiles';
import HandfulOfInformation from '../pagesContent/Home/HandfulOfInformation';
import HowCanWeHelp from '../pagesContent/Home/HowCanWeHelp';
import Segregation from '../pagesContent/Home/Segregation';
import ScrollNavigator from '../components/ScrollNavigator';


const IndexPage = () => {
  const theme = useContext(ThemeContext);
  return (
    <Layout>
      <TopBanner />
      <ScrollNavigator id="sectionOne" />
      <DefaultContainer>
        <DefaultTitle color={theme.colors.dark}>
          Usługi Realizujemy na terenie pomorza
        </DefaultTitle>
        <DefaultParagraph color={theme.colors.dark} align="center">
          Oferujemy darmowy dojazd do klientów mieszkających na terenie Trójmiasta
          lub nie dalej niż 30 km
        </DefaultParagraph>
      </DefaultContainer>
      <StrengthsContainer />
      <Tiles />
      <HandfulOfInformation />
      <HowCanWeHelp />
      <Segregation />
      {/* <TestimonialsSlider /> */}
    </Layout>
  );
};

export default IndexPage;
